<template>
  <div class="joinOliviaIndex">
    <!-- 内容 -->
    <div class="content-box">
      <!-- 奥丽莎品牌 -->
      <div class="one">
        <div class="one-content">
          <div class="name">奥丽莎品牌</div>
          <div class="jieshao">品牌影响力领衔门窗定制行业</div>
          <div class="jieshaos">
            奥丽莎门窗，中国门窗行业头部品牌，也是中国系统门窗标准制定单位之一；
            荣获《中国地产家居冠军榜家居行业影响力品牌》、《中国家居产业门窗领军品牌大雁奖》、
            《消费者最喜爱品牌》、《建筑门窗幕墙行业金轩奖》、
            《中国红棉奖-2020产品设计奖》、《央广网2020十大推荐门窗品牌》等200余项殊荣，
            品牌声誉远播海内外，得到行业以及全国消费者的一致认可。
          </div>
        </div>
      </div>
      <!-- 运营推广 -->
      <div class="two">
        <div class="two-content">
          <div class="text-box">
            <div class="name">运营推广</div>
            <div class="text">大力度投入构筑强大宣传攻势</div>
          </div>
          <div class="img-box">
            <img src="../assets/yytg.png" alt="" />
            <!-- <img src="../assets/banner.png" alt="" />
            <img src="../assets/banner.png" alt="" /> -->
          </div>
          <div class="text-box">
            <div class="name">奥丽莎门窗，每年品牌投放多渠道</div>
            <div class="texts">
              涵盖全国机场广告和高铁广告、高速路高炮广告；
              覆盖微信、微博、今日头条、网易、搜狐、 新浪、腾讯、
              凤凰等新媒体传播和新闻客户端，并大力度投放百度引擎，
              实现海陆空全媒体广告投放， 让客户想到就能找到，
              赢得品牌美誉度和知名度，助力终端销售。
            </div>
          </div>
        </div>
      </div>
      <!-- 营销驱动力 -->
      <div class="three">
        <div class="three-content">
          <div class="text-box">
            <div class="name">营销驱动力</div>
            <div class="text">多维度立体营销制造品牌焦点</div>
          </div>
          <div class="img-box">
            <img src="../assets/yxqd.png" alt="" />
            <!-- <img src="../assets/banner.png" alt="" />
            <img src="../assets/banner.png" alt="" />
            <img src="../assets/banner.png" alt="" />
            <img src="../assets/banner.png" alt="" />
            <img src="../assets/banner.png" alt="" /> -->
          </div>
        </div>
      </div>
      <!-- 实战支持 -->
      <div class="four">
        <div class="four-content">
          <div class="text-box">
            <div class="name">实战支持</div>
            <div class="text">优秀实战支持团队全面助力终端营销</div>
          </div>
          <div class="img-box">
            <img src="../assets/szzc.png" alt="" />
            <!-- <img src="../assets/banner.png" alt="" />
            <img src="../assets/banner.png" alt="" />
            <img src="../assets/banner.png" alt="" />
            <img src="../assets/banner.png" alt="" />
            <img src="../assets/banner.png" alt="" />
            <img src="../assets/banner.png" alt="" />
            <img src="../assets/banner.png" alt="" /> -->
          </div>
          <div class="text-box">
            <div class="texts">
              奥丽莎在门窗全面推行点将模式，
              快速助力经销商提升经营管理效率和营销推广能力，打开市场,
              拓展客源，真抓实干，提升业绩。
            </div>
          </div>
        </div>
      </div>
      <!-- 奥丽莎产品 -->
      <div class="five">
        <div class="five-content">
          <div class="text-box">
            <div class="name">奥丽莎产品</div>
            <div class="text">设计研发实力质造核心竞争力</div>
          </div>
          <div class="img-box">
            <img src="../assets/cp.png" alt="" />
            <!-- <img src="../assets/banner.png" alt="" />
            <img src="../assets/banner.png" alt="" />
            <img src="../assets/banner.png" alt="" /> -->
          </div>
          <div class="text-box">
            <div class="texts">
              奥丽莎门窗拥有150+项国家专利， 专业质检人员高达100余人。
            </div>
          </div>
        </div>
      </div>
      <!-- 专卖店展示 -->
      <div class="six">
        <div class="six-content">
          <div class="text-box">
            <div class="name">专卖店展示</div>
            <div class="text">“高端定位”支持+“整店输出”模式</div>
          </div>
          <div class="img-box">
            <img src="../assets/zmd.png" alt="" />
            <!-- <img src="../assets/banner.png" alt="" />
            <img src="../assets/banner.png" alt="" />
            <img src="../assets/banner.png" alt="" /> -->
          </div>
          <div class="text-box">
            <div class="texts">
              按照“标准化、分类化、模块化、情景化、体验化”五大维度
              打造适应不同市场、不同店面大小的高品质展厅设计方案，
              让经销商快速上手、快速开业。
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "JoinOliviaIndex",
  data() {
    return {};
  },
  methods: {},
};
</script>

<style scoped lang="less">
@import "../css/joinOliviaIndex.less";
</style>
